const authority = process.env.REACT_APP_ISSUER || process.env.REACT_APP_REACT_AUTHORITY;
const clientId = process.env.REACT_APP_CLIENT_ID;
const redirectUri = process.env.REACT_APP_REDIRECT_URL;
const tokenEndpoint = process.env.REACT_APP_TOKEN_ENDPOINT;
const issuer = process.env.REACT_APP_ISSUER || authority;

export const hasRequiredOidcConfig = Boolean(authority && clientId && redirectUri && tokenEndpoint);

const getAuthReturnPathStorageKey = () => ["oidc", "return-path", authority || window.location.origin, clientId || "default"].join(":");

const hasAuthCallbackParams = (url: URL) => url.searchParams.has("code") || url.searchParams.has("state");

const normalizeSafeReturnPath = (savedPath: string | null) => {
  if (!savedPath || !savedPath.startsWith("/") || savedPath.startsWith("//")) {
    return "/";
  }

  try {
    const returnUrl = new URL(savedPath, window.location.origin);

    if (returnUrl.origin !== window.location.origin) {
      return "/";
    }

    return `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}` || "/";
  } catch {
    return "/";
  }
};

const getSafeReturnPath = () => {
  const savedPath = sessionStorage.getItem(getAuthReturnPathStorageKey());

  return normalizeSafeReturnPath(savedPath);
};

const oidcConfig = {
  authority,
  clientId,
  redirectUri,
  responseType: "code",
  scope: process.env.REACT_APP_SCOPE,
  automaticSilentRenew: true,
  loadUserInfo: true,
  configId: "default",
  authWellknownEndpointUrl: process.env.REACT_APP_AUTH_WELLKNOWN_ENDPOINT_URL,
  silentRenew: true,
  useRefreshToken: true,
  triggerRefreshWhenIdTokenExpired: true,
  allowUnsafeReuseRefreshToken: true,
  onBeforeSignIn: () => {
    const currentUrl = new URL(window.location.href);

    if (!hasAuthCallbackParams(currentUrl)) {
      const returnPath = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}` || "/";
      sessionStorage.setItem(getAuthReturnPathStorageKey(), returnPath);
    }
  },
  onSignIn: () => {
    const returnPath = getSafeReturnPath();
    sessionStorage.removeItem(getAuthReturnPathStorageKey());
    window.history.replaceState({}, document.title, returnPath);
  },
  onSignInError: (error: Error) => {
    console.error("OIDC sign-in failed", error);
  },
  metadata: {
    issuer,
    authorization_endpoint: process.env.REACT_APP_AUTHORIZATION_ENDPOINT,
    token_endpoint: tokenEndpoint,
    userinfo_endpoint: process.env.REACT_APP_USERINFO_ENDPOINT,
  },
};

export default oidcConfig;
